import React from "react";
import { Box, Typography } from "@mui/material";
import {
  TimelineDot,
  TimelineConnector,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineContent,
  TimelineItem as MUITimelineItem,
} from "@mui/lab";
import { useApp } from "context";
import { Custom } from "components";
import { Helpers } from "utils";

type Props = {
  sx?: any;
  dot?: string;
  title?: string;
  header?: string | React.ReactNode;
  subtitle?: string;
  children?: React.ReactNode;
  date?: string | Date;
  description?: string | null;
};

export const TimelineItem = (props: Props) => {
  const { theme } = useApp();

  const isToday = props.date
    ? Helpers.compareTo(new Date(props.date), new Date())
    : false;

  return (
    <MUITimelineItem>
      {props.header && (
        <TimelineOppositeContent
          sx={{
            fontSize: theme.font.md,
            marginLeft: "-100%",
            // marginTop: -theme.margin.xl,
            color: theme.palette.font.color,
          }}
        >
          {props.header}
        </TimelineOppositeContent>
      )}
      <TimelineSeparator>
        {props.dot ? (
          <Typography sx={{ fontSize: theme.font.xxl }}>{props.dot}</Typography>
        ) : (
          <TimelineDot
            sx={{
              backgroundColor: theme.palette.font.color,
            }}
          />
        )}
        <TimelineConnector
          sx={{
            backgroundColor: theme.palette.font.accent,
          }}
        />
      </TimelineSeparator>
      <TimelineContent>
        {props.children ?? (
          <>
            <Typography component="span" sx={{ fontSize: theme.font.md }}>
              {props.title}
            </Typography>
            <Typography
              sx={{
                fontSize: theme.font.sm,
                color: theme.palette.font.accent,
              }}
            >
              {props.subtitle}
            </Typography>
            {isToday && props.description && (
              <Box sx={{ marginTop: theme.margin.xs }}>
                <Custom.Chip label={props.description} size="small" />
              </Box>
            )}
          </>
        )}
      </TimelineContent>
    </MUITimelineItem>
  );
};
